import BaseAPI from '@/apis/base/baseApi';
import httpClient from '@/apis/base/httpclient';

class ProxyLogAPI extends BaseAPI {
	constructor() {
		super();
	}
	apiName = 'Business';
	controllerName = 'proxylog';

	getHistorys(payload) {
		let request = {
			url: `${this.getAPIUrl()}/history?`,
			data: payload
		};

		return httpClient.postAsync(request);
	}
	
	getHistory(proxyId, payload) {
		let request = {
			url: `${this.getAPIUrl()}/${proxyId}/history`,
			data: payload
		};

		return httpClient.postAsync(request);
	}
}

export default new ProxyLogAPI();
